import React from "react";
import Service from "./webservice/http";
import { storage } from "./utils/storage";

function Maintainence() {
  const services = new Service();

  return (
    <div className="maintainence-container ">
      <div className="p-10 flex items-center justify-between">
        <img src="/assets/images/logo-icon-1.png" alt="dataklout-logo" />
        {storage.getItem("client_logo") ? (
          <img
            src={`${services.domain + storage.getItem("client_logo")}`}
            style={{
              width: "60px",
              height: "40px",
              // borderRadius: "50%",
              // marginBottom: "10px",
            }}
            alt="client-logo"
          />
        ) : (
          ""
        )}
      </div>
      <img
        src="/assets/images/maintainence-header.svg"
        alt="maintainence-header"
        className="w-full"
      />
      <div className="px-48 py-20 flex justify-between">
        <div className=" mt-16">
          <h1 className="text-black" style={{ fontSize: "50px" }}>
            We're Making Things Better
          </h1>
          <p className="text-black mt-4" style={{ fontSize: "30px" }}>
            We're performing some maintenance at the moment.
            <br /> Please check back in about 60 minutes.
          </p>
          <p
            className="mt-32 text-black font-semibold"
            style={{ fontSize: "25px" }}
          >
            Thanks for your patience while we tidy things up.
          </p>
        </div>
        <img
          src="/assets/images/cleaner.png"
          alt="man-cleaning"
          className=""
          style={{ height: "550px" }}
        />
      </div>
      <div className="flex justify-center items-center mt-10">
        <a
          href="mailto:info@dataklout.com"
          className="p-2 text-gray-500"
          style={{ textDecoration: "none" }}
        >
          Contact Email
        </a>
      </div>
    </div>
  );
}

export default Maintainence;
